import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/New-Jersey.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol for Custom Software Development in New Jersey?
            </h2>
            <p>
              Choose TekRevol for leading-edge Custom Software Development in
              New Jersey. Our established expertise and local market
              understanding give your app a competitive edge. Our skilled
              developers embrace the state-of-the-art trends, using advanced
              tools to craft future-ready apps. With agile methodologies, we
              pledge fast results and compliance to developing requirements.
              Beyond deployment, our devoted client support guarantees
              glitch-free performance. We surpass expectations, nurturing
              permanent partnerships through extraordinary service. Experience
              novelty and distinction with TekRevol, where your success story
              begins.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
